import { render, staticRenderFns } from "./MediaShow.vue?vue&type=template&id=6316a5c7&scoped=true"
import script from "./MediaShow.vue?vue&type=script&lang=js"
export * from "./MediaShow.vue?vue&type=script&lang=js"
import style0 from "./MediaShow.vue?vue&type=style&index=0&id=6316a5c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6316a5c7",
  null
  
)

export default component.exports